/**
 * Versioned messages between the SDK client (main thread) and the engine host
 * (Web Worker or in-thread). The protocol version is independent from the package
 * version and the document schema version.
 */
export const PROTOCOL_VERSION = 1;
/** Methods that change the document (followed by scene deltas and events). */
export const MUTATING = new Set([
    'apply',
    'undo',
    'redo',
    'newDocument',
    'loadDotl',
    'loadJson',
    'registerTypes',
    'unregisterType',
    'setTypeEnabled',
    'setSelection',
    'endDrag',
    'importSvg',
    'importDxf',
]);
/** Error raised by SDK calls. */
export class DotloomError extends Error {
    code;
    details;
    constructor(payload) {
        super(payload.message);
        this.name = 'DotloomError';
        this.code = payload.code;
        this.details = payload.details;
    }
}
//# sourceMappingURL=protocol.js.map